import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";

import SideBarLeft from "../layout/SideBarLeft";
import PrivateRoute from './PrivateRoute'
import PublicRoute from "./PrivateRoute"

// ==========> Page <==========
import Login from "../pages/Login"
import Dashboard from "../pages/dashboard/Dashboard"
import Sale from "../pages/sale/Sale"
import Setting from "../pages/setting";
import ProductList from "../pages/product/ProductList";
import DetailProduct from "../pages/product/DetailProduct";
import AddProduct from "../pages/product/add_product";
import EditProduct from "../pages/product/EditProduct";
import ProductType from "../pages/setting/productType/ProductType";
import ExchangeRate from "../pages/setting/exchangeRate/ExchangeRate";
import UnitList from "../pages/setting/unit/UnitList";
import Brand from "../pages/setting/brand/Brand";
import Printer from "../pages/setting/printer/Printer";
import OfferpriceHistory from "../pages/offerprice/offerpricehistory/OfferpriceHistory";
import OfferHistoryDetail from "../pages/offerprice/offerpricehistory/OfferHistoryDetail";
// import Offerprice from "../pages/offerprice/Offerprice";
import SaleHistory from "../pages/offerprice/salehistory";
import SaleHistoryDetail from "../pages/offerprice/salehistory/SaleHistoryDetail";
import SubBrand from "../pages/setting/subbrand/SubBrand";
import BarCodeLaBel from "../pages/setting/barcode/Barcode";
import User from "../pages/setting/user/User";
import ReportCategory from "../pages/dashboard/ReportCategory";
import HIstoryProduct from "../pages/historyproduct/HIstoryProduct";
import Customer from "../pages/setting/customer/Customer";
import AddProductExcel from "../pages/product/product_excel";
import Profile from "../pages/setting/profile/Profile";
import setproduct from "../pages/setting/setproduct/setproduct";
import EmployeeManage from "../pages/setting/user/EmployeeManage";
import ReportProduct from "../pages/dashboard/ReportProduct";
import ReportaAll from "../pages/dashboard/ReportaAll";
import BankAccount from "../pages/setting/BankAccount/BankAccount";
import ReportProductSaleOut from "../pages/dashboard/ReportProductSaleOut";
import { USER_KEY } from "../const";
// import PageNotFound from "../components/PageNotFound";
import ReportCustomer from "../pages/dashboard/ReportCustomer";
import useWindowDimensions from "../helper/windowDimensions";
import ReportIncomeAndCost from "../pages/dashboard/ReportIncomeAndCost";
import CustomerScreen from "../pages/setting/customerscreen/CustomerScreen";
import PurchaseOrder from "../pages/purchaseorder";
import PurchaseOrders from "../pages/purchaseorder/PurchaseOrders";
import PurchaseOrderList from "../pages/purchaseorder/PurchaseOrderList";
import PurchaseOrderHistory from "../pages/purchaseorder/PurchaseOrderHistory";
import PurchaseOrderListDetail from "../pages/purchaseorder/PurchaseOrderListDetail";
import HIstoryIndebted from "../pages/historyindebted/HIstoryIndebted";
import HistoryIndebtedDetail from "../pages/historyindebted/HistoryIndebtedDetail";
import HIstoryIndebtedInfo from "../pages/historyindebted/HIstoryIndebtedInfo";
import ProductDeleted from "../pages/historyproduct/ProductDeleted";

import Stocknotification from "../pages/stocknotification/Stocknotification";
import Offerprice from "../pages/offerprice/offerprice";
import FlyReport from "../pages/report/FlyReport";
// import SaleCategories from "../pages/report/SaleCategories";
import Investment from "../pages/report/Investment";
// import ReportOrderStaff from "../pages/report/ReportOrderStaff";
import ReportStaffs from "../pages/dashboard/ReportStaffs";
import ReportOrderForStaff from "../pages/dashboard/ReportOrderForStaff";
import ReportStock from "../pages/dashboard/ReportStock";
import OrderLists from "../pages/orders/OrderLists";
import NavBarHeader from "../layout/NavBarHeader";
import RolePermission from "../pages/setting/permission/RolePermission";
import LanguageSetting from "../pages/setting/LanguageSetting";
// import SettingMain from "../pages/setting/SettingMain";
import OptionTabs from "../pages/setting/options/OptionTabs";
import CustomerDesktop from "../pages/customerDesktop/CustomerDesktop";
import ShopSettingManagement from "../pages/setting/setproduct/ShopSettingManagement";
import InventoryTabs from "../pages/inventory";
import ReportOptions from "../pages/dashboard/ReportOptions";
import Reward from "../pages/setting/reward/Reward";
import ReportRedeem from "../pages/report/ReportRedeem";


const Main = styled.main`
  /* position: relative; */
  overflow: hidden;
  transition: all 0.15s;
  margin-left: ${(props) => (props.expanded ? 160 : 2)}px;
`;

function Routes() {
  // const [path, setpath] = useState()
  const [expanded, setExpanded] = useState(false);
  const [role, setRole] = useState()
  const user_data = JSON.parse(localStorage.getItem(USER_KEY))
  const { height, width } = useWindowDimensions()
  const sidebarRef = useRef(null);

  const _onToggle = (exp) => {
    setExpanded(exp);
  };

  useEffect(() => {
    if (user_data) {
      setRole(user_data?.data?.role)
    }
  }, [user_data?.data])

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarRef]);

  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/" component={Login} />
        <PublicRoute exact path="/customer_screen" component={CustomerDesktop} />
        <Route
          render={({ location, history }) => (
            <React.Fragment>
              {width > 700 ? <div ref={sidebarRef}><SideBarLeft location={location} history={history} onToggle={_onToggle} expanded={expanded} /></div> : <NavBarHeader />}
              <div>
                <Main expanded={expanded}>
                  <div div style={{ marginTop: 0, minHeight: '100vh', paddingTop: width > 700 ? 0 : 62, marginLeft: width > 700 ? 60 : 0, backgroundColor: "#F4F5FA", }} >
                    <PrivateRoute path="/orders/limit/:limit/page/:skip" exact component={OrderLists} />
                    <PrivateRoute path="/report_staff/limit/:limit/page/:skip" exact component={ReportStaffs} />
                    <PrivateRoute path="/dashboard" exact component={Dashboard} />
                    <PrivateRoute path="/sale_invoice/limit/:limit/page/:skip" exact component={FlyReport} />
                    <PrivateRoute path="/sale/limit/:limit/page/:skip" exact component={Sale} />
                    <PrivateRoute path="/sale_edit/limit/:limit/page/:skip" exact component={Sale} />
                    <PrivateRoute path="/settings" exact component={Setting} />
                    <PrivateRoute path="/settings/bill_setting" exact component={setproduct} />
                    <PrivateRoute path="/settings/shop:id" exact component={ShopSettingManagement} />
                    <PrivateRoute path="/settings/role" exact component={RolePermission} />
                    <PrivateRoute path="/settings/language" exact component={LanguageSetting} />
                    <PrivateRoute path="/settings/option" exact component={OptionTabs} />

                    <PrivateRoute path="/productlist/limit/:limit/page/:skip" exact component={ProductList} />
                    <PrivateRoute path="/stocknotification" exact component={Stocknotification} />
                    <PrivateRoute path="/detailproduct" exact component={DetailProduct} />
                    <PrivateRoute path="/addproduct" exact component={AddProduct} />
                    <PrivateRoute path="/investment/limit/:limit/page/:skip" exact component={Investment} />
                    <PrivateRoute path="/add-product-excel" exact component={AddProductExcel} />
                    <PrivateRoute path="/editproduct" exact component={EditProduct} />
                    <PrivateRoute path="/settings/producttype/limit/:limit/page/:skip" exact component={ProductType} />
                    <PrivateRoute path="/exchangerate" exact component={ExchangeRate} />
                    <PrivateRoute path="/unitlist/limit/:limit/page/:skip" exact component={UnitList} />
                    <PrivateRoute path="/settings/brand/limit/:limit/page/:skip" exact component={Brand} />
                    <PrivateRoute path="/printer/limit/:limit/page/:skip" exact component={Printer} />
                    <PrivateRoute path="/offerprice/limit/:limit/page/:skip" exact component={Offerprice} />
                    <PrivateRoute path="/history_offerprices/limit/:limit/page/:skip" exact component={OfferpriceHistory} />
                    <PrivateRoute path="/offerprice_detail" exact component={OfferHistoryDetail} />
                    <PrivateRoute path="/sale_history/limit/:limit/page/:skip" exact component={SaleHistory} />
                    <PrivateRoute path="/order_detail" exact component={SaleHistoryDetail} />
                    <PrivateRoute path="/settings/subbrand/limit/:limit/page/:skip" exact component={SubBrand} />
                    <PrivateRoute path="/settings/barcode/limit/:limit/page/:skip" exact component={BarCodeLaBel} />
                    <PrivateRoute path="/settings/user" exact component={User} />
                    <PrivateRoute path="/settings/reward" exact component={Reward} />
                    <PrivateRoute path="/sale_categories" exact component={ReportCategory} />
                    <PrivateRoute path="/reportcategory" exact component={ReportCategory} />
                    <PrivateRoute path="/reportproduct" exact component={ReportProduct} />
                    <PrivateRoute path="/reportAll" exact component={ReportaAll} />
                    <PrivateRoute path="/historyproduct/limit/:limit/page/:skip" exact component={HIstoryProduct} />
                    <PrivateRoute path="/settings/customer/limit/:limit/page/:skip" exact component={Customer} />
                    <PrivateRoute path="/settings/profile" exact component={Profile} />
                    <PrivateRoute path="/employeemanage" exact component={EmployeeManage} />
                    <PrivateRoute path="/settings/bank" exact component={BankAccount} />
                    <PrivateRoute path="/reportproductsaleout" exact component={ReportProductSaleOut} />
                    <PrivateRoute path="/reportcustomer" exact component={ReportCustomer} />
                    <PrivateRoute path="/report_income" exact component={ReportIncomeAndCost} />
                    <PrivateRoute path="/customerscreen" exact component={CustomerScreen} />
                    <PrivateRoute path="/purchase_management" exact component={PurchaseOrder} />
                    <PrivateRoute path="/purchaseorders/limit/:limit/page/:skip" exact component={PurchaseOrders} />
                    <PrivateRoute path="/purchase_orders" exact component={PurchaseOrderList} />
                    <PrivateRoute path="/purchase_order_detail" exact component={PurchaseOrderListDetail} />
                    <PrivateRoute path="/history_purchase_order" exact component={PurchaseOrderHistory} />
                    <PrivateRoute path="/history_indebted" exact component={HIstoryIndebted} />
                    <PrivateRoute path="/indebted_detail/:id" exact component={HistoryIndebtedDetail} />
                    <PrivateRoute path="/promissory_note" exact component={HIstoryIndebtedInfo} />
                    <PrivateRoute path="/product_trashed/limit/:limit/page/:skip" exact component={ProductDeleted} />
                    <PrivateRoute path="/order_staff/limit/:limit/page/:skip" exact component={ReportOrderForStaff} />
                    <PrivateRoute path="/report_stock" exact component={ReportStock} />
                    {/* <PrivateRoute path="/report_reward" exact component={ReportReward} /> */}
                    <PrivateRoute path="/report_options" exact component={ReportOptions} />
                    <PrivateRoute path="/report_redeem" exact component={ReportRedeem} />
                    <PrivateRoute path="/inventory/limit/:limit/page/:skip" exact component={InventoryTabs} />
      
                  </div>
                </Main>
              </div>
            </React.Fragment>
          )}
        />
      </Switch>
    </Router >
  );
}

export default Routes;
